import React, { useState } from "react";
import { Navbar, Nav } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import './navbar.css'; // Import your CSS file for custom styles

function MyNavBar() {
    const [activeTab, setActiveTab] = useState("/home");
    const location = useLocation();

    return (
        <Navbar className="justify-content-center navbar my-navbar">
            <Nav variant="pills" activeKey={location.pathname}>
                <Nav.Item>
                    <Nav.Link as={Link} to="/home" eventKey="/home">
                        Home
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link as={Link} to="/about" eventKey="/about">
                        About
                    </Nav.Link>
                </Nav.Item>
                {/* <Nav.Item>
                    <Nav.Link as={Link} to="/scheduling" eventKey="/scheduling">
                        Scheduling
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link as={Link} to="/pay-bill" eventKey="/pay-bill">
                        Pay Bill
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link as={Link} to="/monitoring-contract" eventKey="/monitoring-contract">
                        Monitoring
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link as={Link} to="/fire-alarm-tools" eventKey="/fire-alarm-tools">
                        FA Tools
                    </Nav.Link>
                </Nav.Item> */}
            </Nav>
        </Navbar>
    );
}

export default MyNavBar;